import virtualClassroomStudentRoutes from 'modules/virtualClassrooms/common/routing/studentRoutes'

const routes = {
  root: `${virtualClassroomStudentRoutes.root}/details/presenter/schedule`,
}

export default routes
